import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { preloadComponent } from "../utils/lazyLoad";

// Import functions for preloading
const preloadDashboard = () => import("../view/DashboardCalculator");
const preloadConfiguration = () => import("../view/DisplayConfiguration");
const preloadScenarios = () => import("../view/ScenarioSelection");
const preloadMockup = () => import("../view/DesiredMockup");
const preloadViewer = () => import("../view/ImageViewer");

const PreloadManager = () => {
  const location = useLocation();

  useEffect(() => {
    // Preload components based on current route
    const preloadBasedOnRoute = () => {
      const path = location.pathname;

      switch (path) {
        case "/":
          // Preload likely next components
          preloadComponent(preloadConfiguration);
          preloadComponent(preloadScenarios);
          break;
        case "/display-configuration":
          // Preload related components
          preloadComponent(preloadScenarios);
          preloadComponent(preloadMockup);
          break;
        case "/scenario-selection":
          // Preload next step components
          preloadComponent(preloadMockup);
          preloadComponent(preloadViewer);
          break;
        case "/desired-mockup":
          // Preload final components
          preloadComponent(preloadViewer);
          break;
        default:
          // Preload main components for any other route
          preloadComponent(preloadDashboard);
          break;
      }
    };

    // Add a small delay to avoid blocking the current render
    const timeoutId = setTimeout(preloadBasedOnRoute, 100);

    return () => clearTimeout(timeoutId);
  }, [location.pathname]);

  // This component doesn't render anything
  return null;
};

export default PreloadManager;
